import { render, staticRenderFns } from "./AnswerComponent.vue?vue&type=template&id=139aae92&scoped=true"
import script from "./AnswerComponent.vue?vue&type=script&lang=js"
export * from "./AnswerComponent.vue?vue&type=script&lang=js"
import style0 from "./AnswerComponent.vue?vue&type=style&index=0&id=139aae92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139aae92",
  null
  
)

export default component.exports